export const getResult = (state, id) => state.result.results.entries[id];
